module.exports = __webpack_public_path__ + "img/3.dc442351.png";